import m from "../../geodata/es2015/newZealandLow";
window.am4geodata_newZealandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/newZealandLow.js
// module id = null
// module chunks = 